import React from 'react';
import { FallbackComponent } from 'components';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 以便下一次渲染能夠顯示錯誤 UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // 你可以在這裡將錯誤記錄到 console，或是發送到你自己的後端 API
    console.error('Uncaught error:', error, errorInfo);

    // 如果你想透過 GA 追蹤錯誤，也可以在這裡呼叫 ReactGA
    // if (window.gtag) {
    //   window.gtag('event', 'exception', {
    //     'description': error.message,
    //     'fatal': false
    //   });
    // }
  }

  render() {
    if (this.state.hasError) {
      // 渲染自定義的 Fallback UI
      return <FallbackComponent error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
